module.exports = __webpack_public_path__ + "313670ea84d1f36d8413f4c9f327b9c9.jpg";